import { GetStaticProps } from "next";
import { QueryClient, dehydrate } from "react-query";

import { ReviewContainer } from "@/containers/ReviewContainer";
import { getPaginationReviews } from "@/containers/ReviewContainer/remotes/getReviews";
import RichSearch from "@/components/common/RichSearch";
import {
  AggregateRatingVariable,
  getAggregateRating,
  getReviewRichSearch,
  ReviewOmitContentType,
} from "@/utils/richSearch";
import { 후기_리치서치_컨텐츠_개수들, 후기_리치서치_컨텐츠들 } from "@/constants/richSearch/review";

import Head from "next/head";

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchInfiniteQuery(
    ["sangjoReviews", "전체보기"],
    ({ pageParam = 1 }) => getPaginationReviews(pageParam),
    {
      getNextPageParam: () => null, // pageParams를 null로 초기화
    },
  );

  const pageKeywords = `상조, 상조 서비스, 상조 후기, 장례, 장례 상조, 장례식장, 장례 상조, 장례식장 상조, 고이, 고이 후기`;
  const pageOgTitle = "고이 상조서비스 이용 후기 | 투명하고 정직한 장례, 고이";
  const pageDescription =
    "고이장례연구소의 상조 서비스를 이용하신 분들의 소중한 후기를 소개합니다. 비슷한 고민을 가지고 계시거나, 비슷한 상황에서 장례를 준비하셨던 분들의 후기를 살펴보세요. 고이장례연구소는 정성 어린 서비스와 신뢰할 수 있는 상조 서비스를 제공하고 있습니다.";

  return {
    props: {
      richSearchName: pageOgTitle,
      pageDescription: pageDescription,
      pageKeywords,
      pageOgTitle,
      pageOgDescription: pageDescription,
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      // pageOgImage: parlor?.images[0]?.url || `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png`,
    },
    revalidate: 5,
  };
};

export default function ReviewPage({ richSearchName }: { richSearchName: string }) {
  const reviewRichSearchData: ReviewOmitContentType[] = 후기_리치서치_컨텐츠들.전체.map(
    (reviewBody, index) => ({
      reviewBody,
      author: {
        "@type": "Person",
        name: "상주" + index,
      },
    }),
  );

  const reviewRichSearch = getReviewRichSearch(richSearchName, reviewRichSearchData);
  const aggregateRatingVariable: AggregateRatingVariable = {
    name: richSearchName,
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: "5",
      ratingCount: 후기_리치서치_컨텐츠_개수들.전체,
      ratingValue: "4.9",
      reviewCount: 후기_리치서치_컨텐츠_개수들.전체,
    },
  };

  const aggregateRating = getAggregateRating("Product", aggregateRatingVariable);
  const aggregateRatingAndReview = { ...aggregateRating, ...reviewRichSearch };

  return (
    <>
      <RichSearch data={aggregateRatingAndReview} />
      <Head>
        <meta property="og:url" content="https://www.goifuneral.co.kr/review/" />
        <link rel="canonical" href="https://www.goifuneral.co.kr/review/" key="canonical" />
      </Head>
      <ReviewContainer />
    </>
  );
}
